
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPanelIlluminationProposal as ObiPanelIlluminationProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-panel-illumination-proposal.js';
 
 
 

 
 export const ObiPanelIlluminationProposal = createComponent({
   react: React,
   tagName: 'obi-panel-illumination-proposal',
   elementClass: ObiPanelIlluminationProposalElement,
   events: {
     
   }
  });
 
 